let _file: File | null = null;

export const ocrImageStore = {
  set: (file: File) => { _file = file; },
  consume: (): File | null => { const v = _file; _file = null; return v; },
};
